<div [@routeAnimations]="getRouteAnimationData()" class="relative w-full h-full">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<app-loading-overlay></app-loading-overlay>
<app-toast-container></app-toast-container>
<app-modal-host />
